import { useEffect, useState } from 'react'
import { BrowserView, MobileView } from 'react-device-detect'
import CountUp from 'react-countup'
import axios from 'axios'
import { Parallax } from 'react-scroll-parallax'
import { Zoom } from 'react-awesome-reveal'
import '../../styles/Home/HomeCounter.css'

function HomeCounter() {

    const [counters, setCounters] = useState(null)

    useEffect(() => {

        getCounter()

    }, [])

    function getCounter() {

        axios.get(process.env.REACT_APP_API_URL + 'counter').then((response) => {
            if (response.data) {
                response.data.updatedAt = new Date(response.data.updatedAt).toLocaleDateString("fr-FR", { hour: 'numeric', minute: 'numeric' })
                setCounters(response.data)
            }
        }).catch((error) => {
            console.log("error :\n" + JSON.stringify(error) + "\n\n")
        })

    }

    return (

        <>
            <BrowserView>
                {counters ?
                    <Parallax speed={20}>
                        <div className='homeCounter'>
                            <div className='homeCounterCounters'>
                                <div className='homeCounterCounter'>
                                    <Zoom duration={500}>
                                        <CountUp
                                            end={counters.counter1}
                                            duration={3}
                                            redraw={true}
                                            separator={" "}
                                            className={'homeCounterCounterNumber'}
                                        />
                                        <div className='homeCounterCounterText'>{counters.counter1Label}</div>
                                    </Zoom>
                                </div>
                                <div className='homeCounterCounter'>
                                    <Zoom duration={500}>
                                        <CountUp
                                            end={counters.counter2}
                                            duration={3}
                                            redraw={true}
                                            separator={" "}
                                            className={'homeCounterCounterNumber'}
                                        />
                                        <div className='homeCounterCounterText'>{counters.counter2Label}</div>
                                    </Zoom>
                                </div>
                                <div className='homeCounterCounter'>
                                    <Zoom duration={500}>
                                        <CountUp
                                            end={counters.counter3}
                                            duration={3}
                                            redraw={true}
                                            separator={" "}
                                            className={'homeCounterCounterNumber'}
                                        />
                                        <div className='homeCounterCounterText'>{counters.counter3Label}</div>
                                    </Zoom>
                                </div>
                                <div className='homeCounterCounter'>
                                    <Zoom duration={500}>
                                        <CountUp
                                            end={counters.counter4}
                                            duration={3}
                                            redraw={true}
                                            separator={" "}
                                            className={'homeCounterCounterNumber'}
                                        />
                                        <div className='homeCounterCounterText'>{counters.counter4Label}</div>
                                    </Zoom>
                                </div>
                            </div>
                        </div>
                    </Parallax>
                    : null
                }
            </BrowserView>

            <MobileView>
                {counters ?
                    <Parallax speed={20}>
                        <div className='homeCounterCounterMobile'>
                            {/* <div className='homeCounterCounters'> */}
                            <div className='homeCounterCounterMobile'>
                                {/* <Zoom duration={500}> */}
                                <CountUp
                                    end={counters.counter1}
                                    duration={3}
                                    redraw={true}
                                    separator={" "}
                                    className={'homeCounterCounterNumberMobile'}
                                />
                                <div className='homeCounterCounterTextMobile'>{counters.counter1Label}</div>
                                {/* </Zoom> */}
                            </div>
                            <div className='homeCounterCounterMobile'>
                                {/* <Zoom duration={500}> */}
                                <CountUp
                                    end={counters.counter2}
                                    duration={3}
                                    redraw={true}
                                    separator={" "}
                                    className={'homeCounterCounterNumberMobile'}
                                />
                                <div className='homeCounterCounterTextMobile'>{counters.counter2Label}</div>
                                {/* </Zoom> */}
                            </div>
                            <div className='homeCounterCounterMobile'>
                                {/* <Zoom duration={500}> */}
                                <CountUp
                                    end={counters.counter3}
                                    duration={3}
                                    redraw={true}
                                    separator={" "}
                                    className={'homeCounterCounterNumberMobile'}
                                />
                                <div className='homeCounterCounterTextMobile'>{counters.counter3Label}</div>
                                {/* </Zoom> */}
                            </div>
                            <div className='homeCounterCounterMobile'>
                                {/* <Zoom duration={500}> */}
                                <CountUp
                                    end={counters.counter4}
                                    duration={3}
                                    redraw={true}
                                    separator={" "}
                                    className={'homeCounterCounterNumberMobile'}
                                />
                                <div className='homeCounterCounterTextMobile'>{counters.counter4Label}</div>
                                {/* </Zoom> */}
                            </div>
                            {/* </div> */}
                        </div>
                    </Parallax>
                    : null
                }
            </MobileView>
        </>

    )

}

export default HomeCounter
